import {
    ACCOUNTS_PROMILES_REQUEST_OPEN_MODAL,
    ACCOUNTS_PROMILES_REQUEST_REQUEST,
    ACCOUNTS_PROMILES_REQUEST_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    account: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case ACCOUNTS_PROMILES_REQUEST_OPEN_MODAL:
            return { ...state, openModal: true, account: action.payload }

        case ACCOUNTS_PROMILES_REQUEST_REQUEST:
            return { ...state, loading: true }

        case ACCOUNTS_PROMILES_REQUEST_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "ACCOUNTS_PROMILES_REQUEST"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};